
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"colorable",attrs:{"d":"M27.5 29.712c-5.02 0-9.088 4.399-9.088 9.825 0 5.427 4.069 9.826 9.088 9.826 1.651 0 3.21-.488 4.544-1.32v1.32c0 2.713-2.034 4.912-4.544 4.912-1.776 0-3.285-1.127-4.033-2.732l-4.09 2.21c1.49 3.227 4.56 5.435 8.123 5.435 5.02 0 9.088-4.399 9.088-9.825v-9.826c0-5.426-4.069-9.825-9.088-9.825zm0 4.913c2.51 0 4.544 2.2 4.544 4.912 0 2.714-2.034 4.913-4.544 4.913s-4.544-2.2-4.544-4.913 2.034-4.912 4.544-4.912zM22.956 60.17v1.966h9.088V60.17z","fill-rule":"evenodd"}}),_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.596 22.343c2.51 0 4.544-2.2 4.544-4.913v-4.912c0-2.713-2.034-4.913-4.544-4.913s-4.544 2.2-4.544 4.913 2.035 4.912 4.544 4.912c.826 0 1.605-.244 2.272-.66v.66c0 1.357-1.017 2.457-2.272 2.457-.888 0-1.643-.564-2.016-1.367l-2.045 1.106c.745 1.613 2.28 2.717 4.061 2.717zm0-7.369c-1.255 0-2.272-1.1-2.272-2.456 0-1.357 1.017-2.456 2.272-2.456s2.272 1.1 2.272 2.456c0 1.356-1.017 2.456-2.272 2.456zM43.404 66.557c-2.51 0-4.544 2.2-4.544 4.913v4.912c0 2.713 2.034 4.913 4.544 4.913s4.544-2.2 4.544-4.913-2.035-4.912-4.544-4.912c-.826 0-1.605.244-2.272.66v-.66c0-1.357 1.017-2.457 2.272-2.457.888 0 1.643.564 2.016 1.367l2.045-1.106c-.745-1.613-2.28-2.717-4.061-2.717zm0 7.369c1.255 0 2.272 1.1 2.272 2.456 0 1.357-1.017 2.456-2.272 2.456s-2.272-1.1-2.272-2.456c0-1.356 1.017-2.456 2.272-2.456z"}})])])
          )
        }
      }
    